import type { IVisibilityIcon } from './helpers';

export const VisibilityIcon = ({ show = false, ...props }: IVisibilityIcon) => {
	if (show)
		return (
			<svg
				width='20'
				height='21'
				viewBox='0 0 20 21'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...props}
			>
				<path
					opacity='0.4'
					d='M17.7082 8.31745C15.7832 5.29245 12.9665 3.55078 9.99984 3.55078C8.5165 3.55078 7.07484 3.98411 5.75817 4.79245C4.4415 5.60911 3.25817 6.80078 2.2915 8.31745C1.45817 9.62578 1.45817 11.7508 2.2915 13.0591C4.2165 16.0924 7.03317 17.8258 9.99984 17.8258C11.4832 17.8258 12.9248 17.3924 14.2415 16.5841C15.5582 15.7674 16.7415 14.5758 17.7082 13.0591C18.5415 11.7591 18.5415 9.62578 17.7082 8.31745ZM9.99984 14.0591C8.13317 14.0591 6.63317 12.5508 6.63317 10.6924C6.63317 8.83411 8.13317 7.32578 9.99984 7.32578C11.8665 7.32578 13.3665 8.83411 13.3665 10.6924C13.3665 12.5508 11.8665 14.0591 9.99984 14.0591Z'
					fill='white'
				/>
				<path
					d='M10.0005 8.30859C8.69216 8.30859 7.62549 9.37526 7.62549 10.6919C7.62549 12.0003 8.69216 13.0669 10.0005 13.0669C11.3088 13.0669 12.3838 12.0003 12.3838 10.6919C12.3838 9.38359 11.3088 8.30859 10.0005 8.30859Z'
					fill='white'
				/>
			</svg>
		);

	return (
		<svg
			width='20'
			height='21'
			viewBox='0 0 20 21'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g opacity='0.5'>
				<path
					opacity='0.4'
					d='M17.7078 8.31693C17.2995 7.66693 16.8328 7.08359 16.3495 6.55859L13.2078 9.70026C13.3078 10.0086 13.3662 10.3419 13.3662 10.6919C13.3662 12.5586 11.8578 14.0586 9.99951 14.0586C9.64951 14.0586 9.31618 14.0003 9.00785 13.9003L6.12451 16.7836C7.34118 17.4669 8.65785 17.8253 9.99951 17.8253C11.4828 17.8253 12.9245 17.3919 14.2412 16.5836C15.5578 15.7669 16.7412 14.5753 17.7078 13.0586C18.5412 11.7586 18.5412 9.62526 17.7078 8.31693Z'
					fill='white'
				/>
				<path
					d='M11.6829 9.00859L8.31621 12.3753C7.89121 11.9419 7.61621 11.3419 7.61621 10.6919C7.61621 9.38359 8.68288 8.30859 9.99954 8.30859C10.6495 8.30859 11.2495 8.58359 11.6829 9.00859Z'
					fill='white'
				/>
				<path
					opacity='0.4'
					d='M15.2082 5.48411L12.3832 8.30911C11.7748 7.69245 10.9332 7.32578 9.99984 7.32578C8.13317 7.32578 6.63317 8.83411 6.63317 10.6924C6.63317 11.6258 7.00817 12.4674 7.6165 13.0758L4.79984 15.9008H4.7915C3.8665 15.1508 3.0165 14.1924 2.2915 13.0591C1.45817 11.7508 1.45817 9.62578 2.2915 8.31745C3.25817 6.80078 4.4415 5.60911 5.75817 4.79245C7.07484 3.99245 8.5165 3.55078 9.99984 3.55078C11.8582 3.55078 13.6582 4.23411 15.2082 5.48411Z'
					fill='white'
				/>
				<path
					d='M12.3834 10.6924C12.3834 12.0008 11.3167 13.0758 10.0001 13.0758C9.95007 13.0758 9.9084 13.0758 9.8584 13.0591L12.3667 10.5508C12.3834 10.6008 12.3834 10.6424 12.3834 10.6924Z'
					fill='#292D32'
				/>
				<path
					d='M18.1417 2.55078C17.8917 2.30078 17.4834 2.30078 17.2334 2.55078L1.8584 17.9341C1.6084 18.1841 1.6084 18.5924 1.8584 18.8424C1.9834 18.9591 2.14173 19.0258 2.3084 19.0258C2.47507 19.0258 2.6334 18.9591 2.7584 18.8341L18.1417 3.45078C18.4001 3.20078 18.4001 2.80078 18.1417 2.55078Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};
